module.exports = __webpack_public_path__ + "static/bock-a705bf116a7ee00cac013ecf74c05da7.png";